import { ADMIN_ORGANIZATION_LIST } from './index';
import { Action } from '../action';
import { OrganizationInfo } from '@shared/core';

export class AdminOrganizationListInitAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListDestroyAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListHydrateAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListHydrateSuccessAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: OrganizationInfo[],
		public correlationId?: number
	) {}
}

export class AdminOrganizationListHydrateFailureAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListDeleteAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListDeleteSuccessAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.DELETE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListDeleteFailureAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListClickAddAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListClickEditAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListClickDeleteAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.CLICK_DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListSelectAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.SELECT;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListShowGroupsAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.SHOW_GROUPS;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}

export class AdminOrganizationListShowCodesAction implements Action {
	readonly type = ADMIN_ORGANIZATION_LIST.SHOW_CODES;
	constructor(
		public payload: OrganizationInfo,
		public correlationId?: number
	) {}
}
